export default __webpack_public_path__ + "static/media/c4.9f6b5e41.svg";